module.exports = __webpack_public_path__ + "img/logo.5789f7fd.png";